// extracted by mini-css-extract-plugin
export default {"tooltip":"DesktopMobileTooltip_tooltip__P8vDm"};